import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { initCropper } from '../../utils/imageCropper';

export default class CropPhoto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileSource: props.fileSource
    };

    this.cropper = null;
    this.cropperContainer = React.createRef();

    this.root = document.createElement('div');
    document.body.appendChild(this.root);
  }

  componentDidMount() {
    this.initializeCropper();
  }

  componentWillUnmount() {
    document.body.removeChild(this.root);
    this.destroyCropper();
  }

  initializeCropper() {
    this.cropper = initCropper(this.refs.cropperContainer, this.props.ratio || null);
  }

  destroyCropper = () => {
    // destroy и присваивание undef объекту this.cropper делается, дабы в IE/FF/edge не утекала память. в хроме всё ок и без этого.
    this.cropper.destroy();
    this.cropper = undefined;
  };

  sendPhoto = () => {
    this.cropper.getCroppedCanvas().toBlob((blob) => {
      this.props.sendPhoto(blob);
      this.props.close();
    });
  };

  render() {
    return ReactDOM.createPortal(
      <div className="modal-layout" style={{ display: 'flex' }}>
        <div className="modal-main -content">
          <div className="modal-content__wrapper">
            <div className="modal-content">
              <h2 className="modal-title">Выберите загружаемую область изображения.</h2>
              <div className="cropped-image-body">
                <img
                  ref="cropperContainer"
                  className="cropped-image cropped-image-passport"
                  src={this.state.fileSource}
                />
              </div>
              <div className="welcome-modal__button-group">
                <button className="btn" onClick={this.sendPhoto}>
                  Подтвердить
                </button>
                <button className="btn -simple" onClick={this.props.close}>
                  Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>,

      this.root
    );
  }
}

CropPhoto.propTypes = {
  fileSource: PropTypes.string.isRequired,
  sendPhoto: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  ratio: PropTypes.number
};
